import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';

// Plugins
import i18n from '@/plugins/i18n';
import ValidatorPlugin from '@moj/najiz-validators';
import vuetify from '@/plugins/vuetify';
import initializeApplication from '@/plugins/application-initialization';
import najizMui from '@moj/najiz-mui';
import najizToaster, { IToasterAPI } from '@moj/najiz-toastify';
import { TrackerElement } from '@moj/najiz-tracking';

// Components
import App from './App/App';
import AppSvg from '@/components/Svgs/appSvg.vue';

import HttpService from '@/services/httpService';
import UserService from '@/services/userService';
// styles
import './assets/styles/main.scss';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(najizMui);
Vue.use(ValidatorPlugin, { i18n });
Vue.use(najizToaster);

Vue.component('TrackerElement', TrackerElement);
Vue.component('AppSvg', AppSvg);

declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $nToaster: IToasterAPI;
    trackingController:any;
  }
}

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';

initializeApplication().then(() => {
  // const userService = new UserService();
  // userService.httpService = new HttpService();

  // Vue.use(trackingController, {
  //   router,
  //   http,
  //   appInfo: window.$config.ApplicationInsights,
  //   userService,
  // });

  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      HttpService,
      UserService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
